import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/d/src/uu-data-dict/uu-data-dict/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "evenement-tabel"
    }}>{`Evenement-tabel`}</h1>
    <h2 {...{
      "id": "evenementid"
    }}>{`EvenementID`}</h2>
    <p><inlineCode parentName="p">{`EvenementID`}</inlineCode>{` is het unieke nummer van een evenement in Uurwerk. Met dit nummer verbindt Power BI evenementen aan bijhorende `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/dienst#evenementid"
      }}>{`diensten`}</a>{`.`}</p>
    <p><inlineCode parentName="p">{`EvenementID`}</inlineCode>{` is ook handig om twee evenementen met dezelfde naam uit elkaar te kunnen houden. Bijvoorbeeld met een PowerBI `}<em parentName="p">{`measure`}</em>{`:`}</p>
    <pre><code parentName="pre" {...{}}>{`AantalEvenementen = DISTINCTCOUNT(Evenement[EvenementID])
`}</code></pre>
    <h2 {...{
      "id": "evenementnaam"
    }}>{`EvenementNaam`}</h2>
    <p><inlineCode parentName="p">{`EvenementNaam`}</inlineCode>{` geeft de naam weer van een evenement.`}</p>
    <h2 {...{
      "id": "evenementtype"
    }}>{`EvenementType`}</h2>
    <p><inlineCode parentName="p">{`EvenementType`}</inlineCode>{` geeft het type weer van een evenement.`}</p>
    <h2 {...{
      "id": "grootboekcode"
    }}>{`Grootboekcode`}</h2>
    <p><inlineCode parentName="p">{`Grootboekcode`}</inlineCode>{` geeft het financiele kenmerk weer waarop kosten geboekt worden.`}</p>
    {
      /* ## Metingen */
    }
    {
      /* ### AantalEvenementen */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      